import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@env";
import { Observable } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { ErrorHandlingService } from "src/app/features/ada-access/shared/errorHandling/errorHandling.service";
import { API_ENDPOINTS } from "../../secure-blockchain-api-endpoints";
import { FabricChaincode } from "@aptsi-types";

@Injectable({
    providedIn: 'root'
})
export class SmartContractOperationService {

    private baseUrl = environment.apiUrl;

    constructor(
        private http: HttpClient,
        private errorHandlingService: ErrorHandlingService
    ) { }

    // ---------------- LIST ----------------
    getContracts(organizationId: string | null): Observable<FabricChaincode[]> {
        return this.http.post<any>(
            `${this.baseUrl}${API_ENDPOINTS.VIEW.READ}`, { organizationId }
        ).pipe(
            map(res => {
                const key = Object.keys(res)[0];
                return (res[key] ?? []) as FabricChaincode[];
            }),
            catchError(err => this.errorHandlingService.handleError(err))
        );
    }

    // ---------------- GET BY ID ----------------
    getContractById(id: string): Observable<FabricChaincode | null> {
        return this.http.post<any>(
            `${this.baseUrl}${API_ENDPOINTS.OPERATION.READALL}`,
            { chaincodeId: id }
        ).pipe(
            map(res => res['Resource retrieved successfully']?.[0] as FabricChaincode || null),
            catchError(err => this.errorHandlingService.handleError(err))
        );
    }

    // ---------------- SEARCH ----------------
    searchContracts(
        currentPage: number,
        searchText: string,
        category: string,
        organizationId: string | null
    ): Observable<FabricChaincode[]> {
        return this.http.post<any>(
            `${this.baseUrl}${API_ENDPOINTS.VIEW.SEARCH}`,
            { currentPage, searchText, category, organizationId }
        ).pipe(
            map(res => (res.chaincodes || res) as FabricChaincode[]),
            catchError(err => this.errorHandlingService.handleError(err))
        );
    }

    // ---------------- SUBMIT TRANSACTION ----------------
    submitTransaction(data: any) {
        return this.http.post(
            `${this.baseUrl}${API_ENDPOINTS.OPERATION.SUBMIT}`,
            data
        ).pipe(
            catchError(err => this.errorHandlingService.handleError(err))
        );
    }
}